import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import Component from '../components/auth';

import { combineReducers, createStore } from 'redux';

import { default as loginStore } from '@/reducers/login';

const store = createStore(combineReducers({ login: loginStore }));

const app = document.getElementById('root');
const root = createRoot(app);
root.render(
  <Provider store={store}>
    <div>
      <Component />
    </div>
  </Provider>
);

// NOTE: the static boot loader (views/auth.ejs) is removed from INSIDE the Auth
// component via a useEffect — effects run after the browser paints the committed
// DOM, so the login form is already on screen when the loader disappears. Removing
// it here on a timer instead caused a white flash, because this heavy page tree
// hadn't committed yet when the timer fired.
